// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge_Badge__1quPd"};